var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-warpper",
      class: { "loading-translations": !_vm.translationsLoaded }
    },
    [
      !_vm.translationsLoaded
        ? _c("div", { staticClass: "site-loading" }, [_c("circle-loader")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "appbody",
          staticClass: "app-body",
          class: [
            _vm.bodyClass,
            { scrolled: _vm.isScrolled },
            { robo_site: _vm.isReadOnly },
            {
              start_verification_popup_active:
                _vm.loginForTheFirstTime && !_vm.isCustomerVerified
            }
          ],
          style: [
            _vm.shouldSetBackgroundImage
              ? { backgroundImage: _vm.backgroundImageValue }
              : ""
          ],
          attrs: { id: "app-body" }
        },
        [
          _c("div", { staticClass: "header_background" }, [
            _c(
              "div",
              { staticClass: "header_holder" },
              [
                _c("header-part", {
                  style:
                    _vm.tabletAndAbove && _vm.mainColumnWidth > 0
                      ? { width: _vm.mainColumnWidth + "px" }
                      : {},
                  attrs: { id: "header-part" }
                }),
                _vm._v(" "),
                _vm.brandLayout === "generic" &&
                _vm.mobileBigAndBelow &&
                _vm.isRootSportsNavigation
                  ? _c("div", { staticClass: "header_separator" })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.brandLayout !== "generic" &&
            _vm.brandKey !== "sb" &&
            _vm.brandKey !== "mav" &&
            _vm.brandKey !== "qcasino"
              ? _c("div", { staticClass: "sub_header" })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "v-app",
            [
              _c(
                "v-content",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [_c("router-view")],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.mobileBigAndBelow ? _c("bottom-navigation") : _vm._e(),
              _vm._v(" "),
              _vm.gelocationState && !_vm.show2FAPostRegPopup && _vm.isLoggedIn
                ? _c("geolocation-troubleshooter")
                : _vm._e(),
              _vm._v(" "),
              _vm.messageState ? _c("message-dialog") : _vm._e(),
              _vm._v(" "),
              _vm.msgCenterDialog && _vm.brandTemplate === "generic_2"
                ? _c("message-center", {
                    attrs: { "brand-template": _vm.brandTemplate }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.logState ? _c("log-dialog") : _vm._e(),
              _vm._v(" "),
              _vm.sessionDialogIsActive ? _c("session-dialog") : _vm._e(),
              _vm._v(" "),
              _c("PostRegistrationLimits")
            ],
            1
          ),
          _vm._v(" "),
          _vm.termsAndCondtions
            ? _c(
                "div",
                {
                  staticClass: "tandc-popup-container",
                  class: { "tandc-iframe": _vm.tAndCIFrame }
                },
                [
                  _c("div", { staticClass: "tandc-popup-child" }, [
                    _c("span", { staticClass: "tc-heading" }, [
                      _vm._v(_vm._s(_vm.$t("MyAccount.AcceptTermsConditions")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tandc-popup-content" }, [
                      _vm.tAndCText
                        ? _c("div", {
                            staticClass: "tc-text",
                            domProps: { innerHTML: _vm._s(_vm.tAndCText) }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.tAndCIFrame
                      ? _c("iframe", {
                          ref: "tAndCondM",
                          staticClass: "tc-embedded",
                          attrs: {
                            id: "tcIFrame",
                            sandbox: "",
                            srcdoc: _vm.srcdoc
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn primary-btn",
                            on: {
                              click: function($event) {
                                return _vm.toggleTandC("accept")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Account.JoinUs.TC.Accept")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn secondary-btn",
                            on: {
                              click: function($event) {
                                return _vm.toggleTandC("decline")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Account.JoinUs.TC.Decline")))]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.forceTOTPOrMTLVerification && !_vm.isAuthServerEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "tandc-popup-container tandc-iframe post-reg-popup",
                  class: { "z-index-203": !_vm.isLoggedIn }
                },
                [
                  _c(
                    "div",
                    { staticClass: "tandc-popup-child infoVer-popup" },
                    [
                      _c(
                        "div",
                        { staticClass: "form-actions padding-y-20 not-2fa" },
                        [
                          _c(
                            "div",
                            [
                              _c("SecuritySettings", {
                                attrs: { hidePreferences: true }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          0
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn confirm-btn btn-fullwidth border-secondary",
                                      on: {
                                        click: function($event) {
                                          return _vm.closeIs2FaDialog()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MyAccount.FirstTimeLogin.Verification.Postpone"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loginForTheFirstTime &&
          !_vm.isCustomerVerified &&
          !_vm.onPremiseVerification
            ? _c("div", { staticClass: "tandc-popup-container tandc-iframe" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "tandc-popup-child infoVer-popup reg-success-popup"
                  },
                  [
                    _c("RegStepCounter", {
                      staticClass: "reg_ver_register_title",
                      attrs: { currentStep: 5 }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "reg_ver_register" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tandc-popup-content" }, [
                      _c("div", {
                        staticClass: "tc-text text-congrats",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("MyAccount.FirstTimeLogin.Congratulations")
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-actions padding-y-20" }, [
                      _c("p", { staticClass: "text-verify" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MyAccount.FirstTimeLogin.VerificationMessage"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn primary-btn btn-fullwidth",
                              on: {
                                click: function($event) {
                                  return _vm.startVerification()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "MyAccount.FirstTimeLogin.Verification.Start"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "btn confirm-btn btn-fullwidth border-secondary",
                              on: {
                                click: function($event) {
                                  return _vm.remindMeLater()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "MyAccount.FirstTimeLogin.Verification.Postpone"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loginForTheFirstTime &&
          !_vm.isCustomerVerified &&
          _vm.onPremiseVerification
            ? _c("div", { staticClass: "tandc-popup-container tandc-iframe" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "tandc-popup-child infoVer-popup reg-success-popup on-premise-verification"
                  },
                  [
                    _c("div", {
                      staticClass: "tc-text text-congrats",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("MyAccount.FirstTimeLogin.Success")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("RegStepCounter", {
                      staticClass: "reg_ver_register_title",
                      attrs: { currentStep: 5 }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "reg_ver_register" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tandc-popup-content" }, [
                      _c("div", {
                        staticClass: "tc-text success-info",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "MyAccount.FirstTimeLogin.SuccessDescription"
                            )
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-verify" }, [
                      _c("ol", [
                        _c("li", { staticClass: "items-verify" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MyAccount.FirstTimeLogin.VerificationMessage1"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "items-verify" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MyAccount.FirstTimeLogin.VerificationMessage2"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "items-verify" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MyAccount.FirstTimeLogin.VerificationMessage3"
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-actions padding-y-20" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn primary-btn btn-fullwidth",
                              on: {
                                click: function($event) {
                                  return _vm.startVerification()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "MyAccount.FirstTimeLogin.Verification.Start"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "btn confirm-btn btn-fullwidth border-secondary",
                              on: {
                                click: function($event) {
                                  return _vm.remindMeLater()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "MyAccount.FirstTimeLogin.Verification.Postpone"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.show2FAPostRegPopup && !_vm.isAuthServerEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "tandc-popup-container tandc-iframe post-reg-popup",
                  class: { "z-index-203": !_vm.isLoggedIn }
                },
                [
                  _c(
                    "div",
                    { staticClass: "tandc-popup-child infoVer-popup" },
                    [
                      _c(
                        "div",
                        { staticClass: "form-actions padding-y-20 not-2fa" },
                        [
                          _c(
                            "div",
                            [
                              _c("SecuritySettings", {
                                attrs: { hidePreferences: true }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          0
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn confirm-btn btn-fullwidth border-secondary",
                                      on: {
                                        click: function($event) {
                                          return _vm.closeIs2FaDialog()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MyAccount.FirstTimeLogin.Verification.Postpone"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _vm.timeLimitLogout5MinuteAlert
              ? _c(
                  "div",
                  [
                    _c(
                      "v-dialog",
                      {
                        attrs: { "max-width": "400" },
                        model: {
                          value: _vm.timeLimits5MinExpirationDialog,
                          callback: function($$v) {
                            _vm.timeLimits5MinExpirationDialog = $$v
                          },
                          expression: "timeLimits5MinExpirationDialog"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "timelimitspopup" },
                          [
                            _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.PlayLimits.Time.ExpirationInFiveMinutes"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              { staticClass: "accpage" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "success" },
                                    on: {
                                      click: function($event) {
                                        _vm.timeLimits5MinExpirationDialog = false
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Account.Logout.successful.ok")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.timeLimitLogoutOneMinutAlert
              ? _c(
                  "div",
                  [
                    _c(
                      "v-dialog",
                      {
                        attrs: { "max-width": "400" },
                        model: {
                          value: _vm.timeLimits1MinExpirationDialog,
                          callback: function($$v) {
                            _vm.timeLimits1MinExpirationDialog = $$v
                          },
                          expression: "timeLimits1MinExpirationDialog"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "timelimitspopup" },
                          [
                            _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.PlayLimits.Time.ExpirationInOneMinute"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              { staticClass: "accpage" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "success" },
                                    on: {
                                      click: function($event) {
                                        _vm.timeLimits1MinExpirationDialog = false
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Account.Logout.successful.ok")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.mobileBigAndBelow &&
          _vm.brandKey !== "mav" &&
          _vm.brandLayout !== "generic"
            ? _c(
                "v-navigation-drawer",
                {
                  staticClass: "dialog-menu hamburger",
                  attrs: {
                    app: "",
                    fixed: "",
                    "disable-resize-watcher": "",
                    "disable-route-watcher": ""
                  },
                  model: {
                    value: _vm.dialogHamburgerMenu,
                    callback: function($$v) {
                      _vm.dialogHamburgerMenu = $$v
                    },
                    expression: "dialogHamburgerMenu"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _vm.brandLayout !== "generic"
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "logo",
                              on: {
                                click: function($event) {
                                  return _vm.clickOnLogoHandler()
                                }
                              }
                            },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "sports" } } },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.mediaServer(
                                        "/static/brand-img/" +
                                          _vm.brandKey +
                                          "/logo-white.png"
                                      ),
                                      alt: _vm.brandKey
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleHamburgerMenu()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hamburger-menu")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("footer-part"),
          _vm._v(" "),
          _c("headlinesLight", { attrs: { category: "LoginHeadlines" } }),
          _vm._v(" "),
          _vm.welcomeDialog ? _c("welcome-dialog") : _vm._e(),
          _vm._v(" "),
          _vm.authDialog && _vm.isAuthServerEnabled
            ? _c("auth-dialog")
            : _vm._e(),
          _vm._v(" "),
          _c("welcome"),
          _vm._v(" "),
          _c("whats-new"),
          _vm._v(" "),
          _vm.getPopularParlays.active
            ? _c("popular-parlays-dialog")
            : _vm._e(),
          _vm._v(" "),
          _vm.showRecoveryCodesGeneratorDialog && _vm.isAuthServerEnabled
            ? _c("recovery-codes-generator-dialog")
            : _vm._e(),
          _vm._v(" "),
          _c("internal-error")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 